import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge, money, jobTime } from "@/components/status";
import { MapPin, Calendar, Clock } from "lucide-react";

export default function MyJobs() {
  const [jobs, setJobs] = useState([]);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();

  useEffect(() => { api.get("/jobs").then((r) => setJobs(r.data)); }, []);

  const filters = [
    { k: "all", label: "All" },
    { k: "active", label: "Active", statuses: ["accepted", "in_progress"] },
    { k: "pending", label: "Assigned", statuses: ["pending"] },
    { k: "completed", label: "Completed", statuses: ["completed", "approved", "paid"] },
  ];
  const current = filters.find((f) => f.k === filter);
  const shown = filter === "all" ? jobs : jobs.filter((j) => current.statuses.includes(j.status));

  return (
    <div className="space-y-6" data-testid="my-jobs">
      <div>
        <h1 className="font-heading font-black text-3xl tracking-tight text-sapphire">My Jobs</h1>
        <p className="text-muted-foreground text-sm mt-1">Jobs assigned to or accepted by you.</p>
      </div>

      <div className="flex gap-2">
        {filters.map((f) => (
          <button key={f.k} onClick={() => setFilter(f.k)} data-testid={`filter-${f.k}`}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${filter === f.k ? "bg-ocean text-white" : "bg-white border border-border text-slate-600 hover:border-ocean"}`}>
            {f.label}
          </button>
        ))}
      </div>

      <div className="border border-border rounded-md bg-white divide-y divide-border">
        {shown.length === 0 && <div className="p-10 text-center text-sm text-muted-foreground">No jobs in this view.</div>}
        {shown.map((j) => (
          <button key={j.id} onClick={() => navigate(`/jobs/${j.id}`)} className="w-full flex items-center justify-between px-5 py-4 hover:bg-slate-50 text-left transition-colors" data-testid={`myjob-${j.id}`}>
            <div>
              <div className="font-semibold text-sapphire">{j.property?.name}</div>
              <div className="text-sm text-muted-foreground flex flex-wrap items-center gap-3 mt-0.5">
                <span className="flex items-center gap-1"><MapPin className="w-3 h-3" />{j.property?.address}</span>
                <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{j.date}</span>
                <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{jobTime(j)}</span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-heading font-bold text-sapphire">{money(j.payout_amount)}</span>
              <StatusBadge status={j.status} />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
